export default __webpack_public_path__ + "static/hsu_main-a80b81e115dd76dc3da1806babb03e3e.jpg";